<div if.bind="analytics.panelOpen" class="modal-overlay" click.trigger="analytics.closePanel()">
  <div class="analytics-admin" click.trigger="$event.stopPropagation()">
    <div class="analytics-admin__header">
      <h3 class="analytics-admin__title">Signup analytics</h3>
      <button type="button" class="analytics-admin__close" click.trigger="analytics.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="analytics-admin__body">
      <p class="analytics-admin__hint">
        How many visitors arrive, how many are prompted, and how many actually register. Counts are distinct browser sessions, so they approximate people rather than page loads.
      </p>

      <div class="analytics-admin__toolbar">
        <div class="analytics-admin__range">
          <button type="button" class="analytics-admin__range-btn ${analytics.days === 7 ? 'active' : ''}" click.trigger="analytics.setDays(7)" disabled.bind="analytics.loading">7 days</button>
          <button type="button" class="analytics-admin__range-btn ${analytics.days === 30 ? 'active' : ''}" click.trigger="analytics.setDays(30)" disabled.bind="analytics.loading">30 days</button>
          <button type="button" class="analytics-admin__range-btn ${analytics.days === 90 ? 'active' : ''}" click.trigger="analytics.setDays(90)" disabled.bind="analytics.loading">90 days</button>
        </div>
        <button type="button" class="login-btn login-btn--secondary" click.trigger="analytics.load()" disabled.bind="analytics.loading">Refresh</button>
      </div>

      <div if.bind="analytics.error" class="analytics-admin__error">${analytics.error}</div>
      <div if.bind="analytics.loading" class="analytics-admin__status">Loading analytics&hellip;</div>

      <div if.bind="!analytics.loading && analytics.report">
        <div class="analytics-admin__cards">
          <div class="analytics-admin__card">
            <span class="analytics-admin__card-value">${analytics.report.visitSessions}</span>
            <span class="analytics-admin__card-label">Visiting sessions</span>
          </div>
          <div class="analytics-admin__card">
            <span class="analytics-admin__card-value">${analytics.report.signInStarts}</span>
            <span class="analytics-admin__card-label">Started sign-in</span>
          </div>
          <div class="analytics-admin__card">
            <span class="analytics-admin__card-value">${analytics.report.signUps}</span>
            <span class="analytics-admin__card-label">New registrations</span>
          </div>
          <div class="analytics-admin__card analytics-admin__card--accent">
            <span class="analytics-admin__card-value">${analytics.report.signUpRate}%</span>
            <span class="analytics-admin__card-label">Visit &rarr; sign-up</span>
          </div>
        </div>

        <div if.bind="analytics.report.rows.length === 0" class="analytics-admin__status">
          No events recorded in this window yet.
        </div>

        <div if.bind="analytics.report.rows.length > 0" class="analytics-admin__table-wrap">
          <table class="analytics-admin__table">
            <thead>
              <tr>
                <th>Funnel step</th>
                <th class="analytics-admin__num">Sessions</th>
                <th class="analytics-admin__num">Events</th>
              </tr>
            </thead>
            <tbody>
              <tr repeat.for="row of analytics.report.rows">
                <td>
                  <span class="analytics-admin__step">${analytics.label(row.eventName)}</span>
                  <span class="analytics-admin__raw">${row.eventName}</span>
                </td>
                <td class="analytics-admin__num">${row.sessions}</td>
                <td class="analytics-admin__num">${row.count}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
